import config from "../../app.json";
import axios from "axios";

import "./channel-card.scss";
import React, { useEffect, useState, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleRight } from "@fortawesome/free-regular-svg-icons";
import ChannelIcon from "../../Assets/Images/channel-icon.svg";
import ChannelStatus from "../ChannelStatus/channel-status";
import AlertComponent from "../../Components/AlertComponent";
import ChurchModal from "../ChurchModal";
import { Context } from "../../Reducers/Store";

function ChannelCard(props) {
  const {
    id,
    channelId,
    name,
    events,
    index,
    listingEvent,
    deleteApiPath,
    manageApiPath,
    onDelete,
    deleteMessage,
    manageChannel = false,
  } = props;
  
  const [state, dispatch] = useContext(Context);
  const [status, setStatus] = useState(null);
  const [deleteItem, setDeleteItem] = useState({ invisible: false });
  const [urlImage, setUrlImage] = useState(null);

  let navigate = useNavigate();


  useEffect(() => {
    if (state.channelStatus != null) {
      setStatus(state.channelStatus[channelId ?? id] ?? "Loading...");
    }
  }, [state.channelStatus]);

  useEffect(() => {
    if (id) {
      fetchChannelThumbnail();
    }

    return () => {
      if (urlImage != null)
        URL.revokeObjectURL(urlImage);
    };
  }, [id]);

  const setInvis = (invis) => {
    setDeleteItem({ invisible: invis });
  };

  const handleManage = (id) => {
    return navigate(`/manageEvent/${id}`, { replace: false });
  };

  const handleManageChannel = (id) => {
    return navigate(`/manageChannel/${id}`, { replace: false });
  };

  const handleRemove = (id, name) => {
    setDeleteItem({
      invisible: true,
      setInvisible: (invis) => setInvis(invis),
      title: name,
      content: `This channel will be deleted permanently. Confirm deletion?`,
      createItem: `Confirm`,
      discardItem: `Cancel & Close`,
      onSubmit: () => removeChannel(id),
      messageTitle: `Success`,
      message: deleteMessage,
    });
  };

  const removeChannel = (id) => {
    axios.post(config.API + deleteApiPath, { id: id }).then((res) => {
      if (onDelete)
        onDelete();

      return;
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
    });
  };

  const fetchChannelThumbnail = () => {
    axios.post(config.API + "/api/channel/getChannelThumbnail", { id: channelId ?? id }, { responseType: 'blob' }).then((res) => {
      if (res.status === 200 && res.data) {
        setUrlImage(URL.createObjectURL(res.data));
      }
    }).catch(function (error) {
      setUrlImage(null);
    });
  };

  return (
    <div className="list-card-content">
      <div className="event-thumb-container">
        <ChurchModal {...deleteItem} />
        {urlImage == null && (
          <div
            style={{
              width: 50,
              height: 50,
              backgroundImage: "url(" + ChannelIcon + ")",
              backgroundSize: "cover",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 15,
                right: 15,
              }}
            >
              <ChannelStatus status={status} />
            </div>
          </div>
        )}

        {urlImage && (
          <div
            className="elemental-link-preview"
            style={{
              width: "100%",
              height: "100%",
              backgroundImage: "url(" + urlImage + ")",
              backgroundSize: "105%",
              backgroundPosition: "center",
              borderRadius: 20,
              overflow: "hidden",
            }}
          ><span className="device"></span></div>
        )}
      </div>
      <div className="event-card-body">
        <div className="card-top-section">
          <div className="channel-card-name">{name}</div>
          {events?.$values?.length > 0 && (
            <div className="channel-card-in-use">In use by:</div>
          )}
          {events?.$values?.length <= 0 && (
            <div className="channel-not-in-use">
              This channel is not currently being used on any event.
            </div>
          )}
          <div className="events-map">
            {events?.$values?.slice(0, 3).map((x) => (
              <>
                <Row>
                  <Col md={12}>
                    <div className="card-events">
                      <FontAwesomeIcon
                        className="channel-card-element"
                        style={{ color: "#9E9E9E" }}
                        icon={faCircleRight}
                      />
                      <div className="channel-card-element">{`${x.name}: ${x.startTime} - ${x.endTime}`}</div>
                    </div>
                  </Col>
                </Row>
                {/* <Row>
                  {manageApiPath && (
                    <Col className="col-md-6">
                      <Button
                        className={`button-manage`}
                        onClick={() => handleManage(id)}
                      >
                        Manage
                      </Button>
                    </Col>
                  )}
                </Row> */}
              </>
            ))}

          </div>
        </div>
        <div className="cc-card-footer">
          {manageChannel && (
            <Button
              className={`button-manage 2`}
              onClick={() => handleManageChannel(id)}
            >
              Manage
            </Button>
          )}


          <Button
            className={`button-remove`}
            onClick={() => handleRemove(id, name)}
          >
            Remove
          </Button>
        </div>
      </div>

    </div>
  );
}

export default ChannelCard;
